module.exports = __webpack_public_path__ + "static/img/Derick2018.2d991d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/in_loving_memory/Derick2018.jpg
// module id = 144
// module chunks = 4